import React from 'react';

/** `[카테고리] 제목` 형태에서 카테고리만 색·굵게 렌더 (대괄호는 표시하지 않음) */
export function renderTutorialSectionLabel(label: string): React.ReactNode {
  const text = label.trim();
  if (!text) return text;
  const re = /\[([^\]]+)\]/g;
  const parts: React.ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null;
  let key = 0;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(
        <span key={`txt-${key++}`} className="cp-tutorial-section-label-text">
          {text.slice(last, match.index)}
        </span>
      );
    }
    const tagName = (match[1] ?? '').trim();
    if (tagName) {
      parts.push(
        <span key={`tag-${key++}`} className="cp-tutorial-section-tag">
          {tagName}
        </span>
      );
    }
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push(
      <span key={`txt-${key++}`} className="cp-tutorial-section-label-text">
        {text.slice(last)}
      </span>
    );
  }
  return parts.length > 0 ? <>{parts}</> : text;
}
